// extracted by mini-css-extract-plugin
export default {"filterToggle":"NotificationsFilter_filterToggle__rDP7T","badge":"NotificationsFilter_badge__7ncfy","listItems":"NotificationsFilter_listItems__-rnq5"};